import {
  DELETE_ARTIST_PICK,
  LOAD_ARTIST_IDENTITY,
  LOAD_IDENTITY_ANNOUNCEMENTS,
  SAVE_ARTIST_PICK_V2,
  SAVE_BIO,
  UNLOAD_CURRENT_ARTIST,
  UPDATE_ARTISTS_PLAYLISTS,
  UPDATE_GALLERY_IMAGES,
  UPDATE_HEADER_IMAGE,
  UPDATE_IDENTITY_ANNOUNCEMENTS,
  UPDATE_SOCIAL_LINKS,
} from '../actionTypes';
import { loadReducer } from './helpers';

export const identity = (state = null, action) => {
  const hasValidPayload = action.payload && !action.error;

  switch (action.type) {
    case UNLOAD_CURRENT_ARTIST:
      return null;
    case LOAD_ARTIST_IDENTITY:
      return loadReducer(state, action);

    case UPDATE_GALLERY_IMAGES:
      if (hasValidPayload) {
        return {
          ...state,
          data: {
            ...state.data,
            gallery: { images: action.payload },
          },
        };
      }
      return state;

    case UPDATE_HEADER_IMAGE:
      return {
        ...state,
        data: {
          ...state.data,
          header: {
            uri:
              typeof action.payload.header === 'string'
                ? action.payload.header
                : state.data.header && state.data.header.uri,
          },
          avatar: {
            uri:
              typeof action.payload.avatar === 'string'
                ? action.payload.avatar
                : state.data.avatar && state.data.avatar.uri,
          },
        },
      };

    case UPDATE_SOCIAL_LINKS:
      return {
        ...state,
        data: {
          ...state.data,
          autobiography: {
            ...state.data.autobiography,
            links: action.payload,
          },
        },
      };

    case UPDATE_ARTISTS_PLAYLISTS:
      return {
        ...state,
        data: {
          ...state.data,
          playlists: loadReducer(state.data.playlists, action),
        },
      };

    case SAVE_ARTIST_PICK_V2:
      if (action.loadingId) {
        // do some loading state here
        return state;
      }
      if (hasValidPayload) {
        return {
          ...state,
          data: {
            ...state.data,
            pinnedItem: action.payload,
          },
        };
      }
      return state;

    case DELETE_ARTIST_PICK:
      if (action.loadingId) {
        // do some loading state here
        return state;
      }
      if (hasValidPayload) {
        return {
          ...state,
          data: {
            ...state.data,
            pinnedItem: null,
          },
        };
      }
      return state;

    case SAVE_BIO:
      return {
        ...state,
        data: {
          ...state.data,
          autobiography: {
            ...state.data.autobiography,
            body: action.payload,
          },
        },
      };

    case LOAD_IDENTITY_ANNOUNCEMENTS:
      if (hasValidPayload) {
        return {
          ...state,
          data: {
            ...state.data,
            announcements: action.payload,
          },
        };
      }
      return state;
    case UPDATE_IDENTITY_ANNOUNCEMENTS: {
      if (hasValidPayload) {
        return {
          ...state,
          data: {
            ...state.data,
            announcements: [
              ...(state.data.announcements || []),
              ...action.payload.data,
            ],
          },
        };
      }
      return state;
    }

    default:
      return state;
  }
};
